.<style lang="scss" scoped>
.toggle {
    width: 37px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    .toggle-mark {
        height: 20px;
        width: 20px;
        border-radius: 50%;
        background-color: #cccccc;
        position: absolute;
        transition: left 0.15s ease-in-out, background-color 0.15s ease-in-out;
        &.active {
            background-color: var(--accent);
        }
    }
    .toggle-lane {
        width: 34px;
        height: 14px;
        background-color: #efefef;
        border-radius: 16px;
        transition: background-color 0.15s ease-in-out;
        &.active {
            background-color: var(--accent-light);
        }
    }
}
</style>
<template>
    <div class="toggle" :key="_uid" @click="localValue = !localValue; update()">
        <div class="toggle-mark" :style="{ left: (localValue) ? '17px' : '0' }" :class="{ active: localValue }"></div>
        <div class="toggle-lane" :class="{ active: localValue }"></div>
    </div>
</template>
<script>
import isInput from './is-input';

export default {
    name: "el-toggle",

    mixins: [isInput]

}
</script>